import { render } from "./TableBody.vue?vue&type=template&id=7d733d40"
import script from "./TableBody.vue?vue&type=script&lang=js"
export * from "./TableBody.vue?vue&type=script&lang=js"
script.render = render

export default script